import './index.scss';
import React, { Fragment } from 'react';
import { Iconfont } from '@umu/umu-design';
import { defaultIconInfo } from './dataFlow';
import { If } from 'common/src/components';
import { IIconInfo, IMAGE_TYPE } from '../../interface';
import { DEFAULT_NORMAL_ICON_COLOR } from '../../dataFlow';

interface IProps extends React.HTMLAttributes<any> {
    info: IIconInfo;
    isActive: boolean;
}

function IconShow(props: IProps) {
    const { info = defaultIconInfo, className = '', style = {}, isActive, ...rest } = props;
    return (
        <Fragment>
            <If condition={info.iconType === IMAGE_TYPE.SVG}>
                <Iconfont
                    className={`${className} icon-config-svg-nav`}
                    type={isActive ? info.activeIconName || info.iconName : info.iconName}
                    style={{ ...style, color: isActive ? info.color : info.normalColor || DEFAULT_NORMAL_ICON_COLOR }}
                    {...rest}
                />
            </If>
            <If condition={info.iconType === IMAGE_TYPE.CUSTOM}>
                <img
                    className={`${className} icon-config-custom-img-nav`}
                    src={isActive ? info.activeIcon : info.normalIcon}
                    {...rest}
                />
            </If>
        </Fragment>
    );
}

export { IconShow };
